import { useMutation, useQueryClient } from '@tanstack/react-query';
import useFetchWithMsal from "../../../hooks/useFetchWithMsal";
import { protectedResources } from "../../../authConfig";
import { useToast } from "../../../contexts/ToastContext";

export const useTransferApprover = () => {
  const { execute } = useFetchWithMsal({
    scopes: protectedResources.apiScopes.scopes.write,
  });
  
  const { showToast } = useToast();
  const queryClient = useQueryClient();  const transferApprover = async ({ apId, newApproverId, invoiceId }) => {
    try {
      const response = await execute(
        "PUT",
        `${process.env.REACT_APP_BACKEND_BASE_URL}/api/invoice-roles/transfer-approver`,
        { apId, newApproverId, invoiceId }
      );
      
      await Promise.all([
        queryClient.invalidateQueries(['invoices']),
        queryClient.invalidateQueries(['approvalPackages']),
        queryClient.invalidateQueries(['spInvoices']),
        new Promise(resolve => setTimeout(resolve, 1000))
      ]);
      
      return response;
    } catch (error) {
      console.error('Error transferring approver:', error);
      throw error;
    }
  };

  const mutation = useMutation({
    mutationFn: transferApprover,
    onSuccess: (data) => {
      // Add a small delay before showing success and updating UI for better UX
      setTimeout(() => {
        showToast(
          `המאשר הועבר בהצלחה ל${data.data.newApproverFullName}`, 
          "success"
        );

        // Trigger immediate UI updates
        const event = new CustomEvent('approver-transferred', { 
          detail: { 
            invoiceId: data.data.invoiceId,
            newApproverId: data.data.newApproverId,
            newApproverName: data.data.newApproverFullName
          }
        });
        window.dispatchEvent(event);

        // Refresh queries in background after additional delay
        setTimeout(() => {
          queryClient.invalidateQueries(['invoices']);
          queryClient.invalidateQueries(['approvalPackages']);
          queryClient.invalidateQueries(['spInvoices']);
        }, 1000);
      }, 1500); // 1.5 second delay to show loading and let changes process
    },
    onError: (error) => {
      const errorMessage = error.response?.data?.message || 
                          error.message || 
                          "שגיאה בהעברת המאשר";
      showToast(errorMessage, "error");
      console.error('Transfer approver error:', error);
    }
  });

  return {
    transferApprover: mutation.mutate,
    isTransferring: mutation.isPending,
    error: mutation.error
  };
};